module.exports = __webpack_public_path__ + "img/w_billable rate.4bcc4573.svg";